import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { IconSizesEnum, IIcon } from '../../../../../icon/icon.component';

@Component({
  selector: 'i2g-rating-icon',
  templateUrl: 'rating-icon.component.html',
  styleUrls: ['rating-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingIconComponent implements OnInit {
  /**
   * Used for input radio id attribute
   */
  @Input() id: string;

  /**
   * Used for input radio name attribute
   */
  @Input() name: string;

  /**
   * Used for rating icon size
   */
  @Input() size: IconSizesEnum;

  /**
   * Width in pixel, pass this for size `custom`
   */
  @Input() width: number;

  /**
   * Height in pixel, pass this for size `custom`
   */
  @Input() height: number;

  /**
   * Rating value
   */
  @Input() value: number;

  /**
   * Determine whether rating color should be filled
   */
  @Input() filled: boolean;

  /**
   * Used for input radio checked attribute
   */
  @Input() checked: boolean;

  /**
   * Determine if rating icon is readonly
   */
  @Input() readonly = false;

  @Output() clickRatingIcon = new EventEmitter<number>();

  /**
   * Used for label and aria
   */
  label: string;

  svgIconSizeClass: string;

  starRatingIcon: IIcon;
  starRatingIconName: string;

  constructor() {}

  ngOnInit() {
    // only support English for label
    this.label = `${this.value} ${this.value !== 1 ? 'Stars' : 'Star'}`;

    // ensure the naming uniqueness
    this.starRatingIconName = `${this.name}-${this.value}`;

    this.starRatingIcon = {
      name: this.starRatingIconName,
      size: this.size,
    };
  }

  onClick() {
    this.filled = true;
    this.clickRatingIcon.emit(this.value);
  }
}
